// Global Components
import * as React from 'react';

// Types
type $Props = {
  label: string;
};

function NoDataView({
  label,
}: $Props) {
  return (
    <div className={'NoData text-gray-600 flex items-center justify-center py-5'}>
      <em className={'la la-water text-2xl mr-2'} />
      <span>{label}</span>
    </div>
  );
}

export default NoDataView;
